(function () {
  const parseI18n = (root) => {
    const node = root.querySelector('[data-product-reviews-i18n]');
    if (!node) {
      return {};
    }
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  };

  const formatDateFromIso = (iso) => {
    if (!iso) {
      return '';
    }
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const getCommentDateLabel = (comment) => {
    if (comment.displayDate) {
      return comment.displayDate;
    }
    return formatDateFromIso(comment.commentDate || comment.createdAt);
  };

  const getCommentDateTime = (comment) => {
    return comment.commentDate || comment.createdAt || '';
  };

  const cloneStarIcon = (root, isEmpty) => {
    const template = root.querySelector('[data-product-reviews-star-template]');
    if (!template || !template.content.firstElementChild) {
      return null;
    }
    const star = template.content.firstElementChild.cloneNode(true);
    if (isEmpty) {
      star.classList.add('is-empty');
    }
    return star;
  };

  const buildStars = (rating, root) => {
    const value = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    const wrap = document.createElement('span');
    wrap.className = 'product-reviews__stars';
    wrap.setAttribute('aria-label', `${value}/5`);

    for (let index = 1; index <= 5; index += 1) {
      const star = cloneStarIcon(root, index > value);
      if (star) {
        wrap.appendChild(star);
      }
    }

    return wrap;
  };

  const computeAverageRating = (items) => {
    if (!items.length) {
      return 0;
    }
    const sum = items.reduce((total, item) => total + (Number(item.rating) || 0), 0);
    return sum / items.length;
  };

  const formatAverageScore = (average) => {
    const rounded = Math.round(average * 10) / 10;
    return rounded.toFixed(1);
  };

  const sortCommentsNewest = (items) => {
    const list = items.slice();
    list.sort((a, b) => {
      const timeA = new Date(a.commentDate || a.createdAt).getTime();
      const timeB = new Date(b.commentDate || b.createdAt).getTime();
      return timeB - timeA;
    });
    return list;
  };

  const buildReviewCountLabel = (count, template) => {
    if (!template) {
      return String(count);
    }
    return template.replace(/\{\{\s*count\s*\}\}/g, String(count));
  };

  const updateReviewsTabLabel = (tabsRoot, count) => {
    if (!tabsRoot) {
      return;
    }
    const tab = tabsRoot.querySelector('[data-product-tab="reviews"]');
    if (!tab) {
      return;
    }
    const base = tab.dataset.productTabReviewsLabel || tab.textContent.trim();
    if (count > 0) {
      tab.textContent = `${base} (${count})`;
    } else {
      tab.textContent = base;
    }
  };

  const createCard = (comment, i18n, root) => {
    const card = document.createElement('article');
    card.className = 'product-reviews__card';

    card.appendChild(buildStars(comment.rating, root));

    const body = document.createElement('div');
    body.className = 'product-reviews__card-body';
    body.textContent = comment.body || '';
    card.appendChild(body);

    if (comment.imageUrl) {
      const media = document.createElement('div');
      media.className = 'product-reviews__card-media';
      const img = document.createElement('img');
      img.src = comment.imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 96;
      img.height = 96;
      media.appendChild(img);
      card.appendChild(media);
    }

    const foot = document.createElement('div');
    foot.className = 'product-reviews__card-foot';

    const meta = document.createElement('div');
    meta.className = 'product-reviews__card-meta';

    const name = document.createElement('span');
    name.className = 'product-reviews__card-name';
    name.textContent = comment.displayName || i18n.guestName || '';

    const divider = document.createElement('span');
    divider.className = 'product-reviews__card-meta-divider';
    divider.setAttribute('aria-hidden', 'true');

    const dateLabel = getCommentDateLabel(comment);
    const date = document.createElement('time');
    date.className = 'product-reviews__card-date';
    date.dateTime = getCommentDateTime(comment);
    date.textContent = dateLabel;

    meta.appendChild(name);
    meta.appendChild(divider);
    meta.appendChild(date);
    foot.appendChild(meta);
    card.appendChild(foot);

    return card;
  };

  const initReviewsRoot = (root) => {
    if (root.dataset.productReviewsInitialized === 'true') {
      return;
    }

    const apiBase = root.dataset.productReviewsApi || 'https://joker-baby-shopify-app.vercel.app';
    const shop =
      typeof window.jokerStorefrontShop === 'function'
        ? window.jokerStorefrontShop(root.dataset.productReviewsShop)
        : String(root.dataset.productReviewsShop || '').trim().toLowerCase();
    const productId = root.dataset.productReviewsProductId || '';
    const limit = Math.min(50, Math.max(4, Number(root.dataset.productReviewsLimit) || 20));
    const i18n = parseI18n(root);

    const loadingEl = root.querySelector('[data-product-reviews-loading]');
    const errorEl = root.querySelector('[data-product-reviews-error]');
    const emptyEl = root.querySelector('[data-product-reviews-empty]');
    const filledEl = root.querySelector('[data-product-reviews-filled]');
    const listEl = root.querySelector('[data-product-reviews-list]');
    const summaryCountEl = root.querySelector('[data-product-reviews-summary-count]');
    const summaryStarsEl = root.querySelector('[data-product-reviews-summary-stars]');
    const summaryScoreEl = root.querySelector('[data-product-reviews-summary-score]');

    if (!listEl || !apiBase || !shop || !productId) {
      return;
    }

    const tabsRoot = root.closest('[data-product-tabs]');
    let loadStarted = false;

    const setVisible = (node, visible) => {
      if (!node) {
        return;
      }
      if (visible) {
        node.removeAttribute('hidden');
      } else {
        node.setAttribute('hidden', '');
      }
    };

    const showLoading = () => {
      setVisible(loadingEl, true);
      setVisible(errorEl, false);
      setVisible(emptyEl, false);
      setVisible(filledEl, false);
    };

    const showError = (message) => {
      setVisible(loadingEl, false);
      setVisible(emptyEl, false);
      setVisible(filledEl, false);
      if (errorEl) {
        errorEl.textContent = message || '';
      }
      setVisible(errorEl, true);
    };

    const showEmpty = () => {
      setVisible(loadingEl, false);
      setVisible(errorEl, false);
      setVisible(filledEl, false);
      setVisible(emptyEl, true);
      updateReviewsTabLabel(tabsRoot, 0);
    };

    const renderSummary = (comments) => {
      const count = comments.length;
      const average = computeAverageRating(comments);

      if (summaryCountEl) {
        summaryCountEl.textContent = buildReviewCountLabel(count, i18n.reviewCount);
      }

      if (summaryStarsEl) {
        summaryStarsEl.innerHTML = '';
        summaryStarsEl.appendChild(buildStars(average, root));
      }

      if (summaryScoreEl) {
        summaryScoreEl.textContent = formatAverageScore(average);
      }

      updateReviewsTabLabel(tabsRoot, count);
    };

    const renderList = (comments) => {
      listEl.innerHTML = '';
      const sorted = sortCommentsNewest(comments);

      if (sorted.length === 0) {
        showEmpty();
        return;
      }

      setVisible(loadingEl, false);
      setVisible(errorEl, false);
      setVisible(emptyEl, false);
      setVisible(filledEl, true);

      renderSummary(sorted);

      sorted.forEach((comment) => {
        listEl.appendChild(createCard(comment, i18n, root));
      });
    };

    const loadComments = async () => {
      if (loadStarted) {
        return;
      }
      loadStarted = true;
      showLoading();
      listEl.innerHTML = '';

      const url = `${apiBase.replace(/\/$/, '')}/api/storefront/comments?shop=${encodeURIComponent(shop)}&productId=${encodeURIComponent(productId)}&limit=${encodeURIComponent(String(limit))}`;

      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('fetch failed');
        }
        const payload = await response.json();
        const comments = Array.isArray(payload.comments) ? payload.comments : [];
        renderList(comments);
      } catch (error) {
        showError(i18n.loadError || '');
      }
    };

    loadComments();
    root.dataset.productReviewsInitialized = 'true';
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-product-reviews]').forEach(initReviewsRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
